import {getCurrentApiUrl} from '../utils/backendConfig'

// Dynamic API base URL based on active backend configuration
const getApiBaseUrl = () => getCurrentApiUrl()

export const API_ENDPOINTS = {
  //   USERS: `${getApiBaseUrl()}/users`,
  //   PATIENTS: `${getApiBaseUrl()}/patients`,
  //   LOGIN: `${getApiBaseUrl()}/auth/login`,
  //   REGISTER: `${getApiBaseUrl()}/auth/register`,
  PROFILE_UPDATE: (userId: number | string) => `${getApiBaseUrl()}/users/${userId}`,
  PASSWORD_UPDATE: (userId: number | string) =>
    `${getApiBaseUrl()}/users/${userId}/change-password`,
  FORGOT_PASSWORD: () => `${getApiBaseUrl()}/auth/forgot-password/`,
  RESET_PASSWORD: () => `${getApiBaseUrl()}/auth/reset-password/`,
  VERIFY_RESET_TOKEN: () => `${getApiBaseUrl()}/auth/verify-reset-token/`,
  AUTH_ME: () => `${getApiBaseUrl()}/auth/me`,

  // Doctor
  COUNT_DOCTOR_DEVICES: (doctorId: number | string) =>
    `${getApiBaseUrl()}/doctor-allocated-devices/doctor/${doctorId}/count`,
  COUNT_DOCTOR_RENTAL_DEVICES: (doctorId: number | string) =>
    `${getApiBaseUrl()}/doctor-allocated-devices/doctor/${doctorId}/rental-count`,
  GET_ALL_DOCTOR_DEVICES: (doctorId: number | string, queryParams?: string) =>
    `${getApiBaseUrl()}/doctor-allocated-devices/doctor/${doctorId}${
      queryParams ? `?${queryParams}` : ''
    }`,
  GET_ALL_DOCTOR_AVAILABLE_DEVICES: (doctorId: number | string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/doctor-allocated-devices/doctor/${doctorId}/available${
      queryParams ? `?${queryParams}` : ''
    }`,
  GET_ALL_AVAILABLE_DEVICES: () => `${getApiBaseUrl()}/devices/all-available`,
  RESEND_INVITE_DOCTOR: (doctorId: number) =>
    `${getApiBaseUrl()}/users/resend-doctor-email?id=${doctorId}`,

  // TODO::Check above if we need 4 or just 1-2 of those APIs

  TRIAL_SUBSCRIPTION_DOCTOR: (id: number, trial_subscription_status: boolean) =>
    `${getApiBaseUrl()}/users/doctor/trial-subscription/${id}?trial_subscription_status=${trial_subscription_status}`,

  GET_DOCTOR_TEAM_DAILY_SUMMARY: (doctor_id: number, today_date_time: string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/time-tracked/doctor/${doctor_id}/daily-team-summary?today_date_time=${today_date_time}${queryParams ? `&${queryParams}` : ''}`,

  DOCTOR_REQUEST_A_DEVICE: (userRole: string) =>
    `${getApiBaseUrl()}/device-request?user_role=${userRole}`,
  GET_ALL_DOCTORS: () => `${getApiBaseUrl()}/users/doctors`,
  GET_DOCTOR_PATIENTS_USAGE_ALERTS: (doctor_id: number, queryParams?: string | null) =>
    `${getApiBaseUrl()}/v1/devicetelemetry/patients-usage-alerts/${doctor_id}${queryParams ? `?${queryParams}` : ''}`,
  GET_PATIENTS_COUNT_SINCE_LAST_READING: (doctor_id: number, queryParams?: string | null) =>
    `${getApiBaseUrl()}/v1/devicetelemetry/patients-count-since-last-reading/${doctor_id}${queryParams ? `?${queryParams}` : ''}`,
  GET_BP_CATEGORIZED_PATIENTS: (doctor_id: number, queryParams?: string | null) =>
    `${getApiBaseUrl()}/v1/devicetelemetry/bp-categorized-patients/${doctor_id}${queryParams ? `?${queryParams}` : ''}`,
  GET_RPM_READINGS_TREND: (queryParams?: string | null) =>
    `${getApiBaseUrl()}/readings/30days-trend${queryParams ? `?${queryParams}` : ''}`,
  GET_BLOOD_PRESSURE_ALERTS: (patientUUID: string) =>
    `${getApiBaseUrl()}/readings/patient-health-alerts/${patientUUID}`,
  UPDATE_READING_ALERT: (patientUUID: string, reading_id: number) =>
    `${getApiBaseUrl()}/v1/devicetelemetry/resolve-reading-alert/${patientUUID}?reading_id=${reading_id}`,
  RESOLVE_ALL_READING_ALERT: () =>
    `${getApiBaseUrl()}/readings/resolve-all-alerts`,
  GET_PATIENT_LAST_30_DAYS_READINGS: (patientUUID: string, monthYear: string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/v1/devicetelemetry/patients/${patientUUID}/readings/last-30-days?month_year=${monthYear}${queryParams ? `&${queryParams}` : ''}`,
  CREATE_MANUAL_BP_ENTRY: (patientUUID: string, userId: string) =>
    `${getApiBaseUrl()}/v1/devicetelemetry/create-manual-entry-for/${patientUUID}/by/${userId}`,
  GET_HEALTH_ALERTS: (patientUUID?: string, queryParams?: string | null) =>
  `${getApiBaseUrl()}/readings/health-alerts?patient_uuid=${patientUUID}${queryParams ? `&${queryParams}` : ''}`,
  // Device Types
  GET_PATIENT_AVERAGE_VITALS: (patientUuid: string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/v1/devicetelemetry/average-vitals/${patientUuid}${queryParams ? `?${queryParams}` : ''}`,

  GET_ALL_DEVICE_TYPES: () => `${getApiBaseUrl()}/device-types`,

  // Devices
  GET_ALL_DEVICES: () => `${getApiBaseUrl()}/devices/all`,
  CREATE_DEVICE: () => `${getApiBaseUrl()}/devices`,
  UPLOAD_DEVICE_CSV: () => `${getApiBaseUrl()}/devices/upload-csv`,
  UPDATE_DEVICE: (deviceId: number | string) => `${getApiBaseUrl()}/devices/${deviceId}`,

  // Patients
  GET_MY_PATIENTS: (queryParams?: string | null) =>
    `${getApiBaseUrl()}/patients/my?${queryParams ? `${queryParams}` : ''}`,
  GET_ACTIVE_PATIENTS_CURRENT_USER: (month_year: string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/patients/active/current?month_year=${month_year}${queryParams ? `&${queryParams}` : ''}`,
  GET_SPECIFIC_PATIENTS: (id: string | undefined, queryParams?: string | null) =>
    `${getApiBaseUrl()}/patients/${id}${queryParams ? `?${queryParams}` : ''}`,
  UPDATE_PATIENT_STATUS: (id: number | undefined, status: number | undefined) =>
    `${getApiBaseUrl()}/patients/update-status/${id}?status=${status}`,

  CREATE_PATIENT: (user_id: number, userRole: string) =>
    `${getApiBaseUrl()}/patients/create/${user_id}?user_role=${userRole}`,
  UPDATE_PATIENT: (patientId: number) => `${getApiBaseUrl()}/patients/update/${patientId}`,
  UPDATE_DOCTOR: (doctorId: number) => `${getApiBaseUrl()}/users/edit-profile/${doctorId}`,
  DELETE_PATIENT: (patientId?: any) => `${getApiBaseUrl()}/patients/delete/${patientId}`,
  GET_PATIENT_READINGS_IN_RANGE: (patientUuid: string, startDate: any, endDate: any, queryParams?: string | null) =>
    `${getApiBaseUrl()}/v1/devicetelemetry/patient/${patientUuid}?start_date=${startDate}&end_date=${endDate}${queryParams ? `&${queryParams}` : ''}`,
  // Current Hiding - Will fix API when resuming work on this
  // GET_PATIENT_STAGES_COMPARISON: (doctor_id: number) =>
  //   `${getApiBaseUrl()}/v1/devicetelemetry/patient-stages-comparison/${doctor_id}`,

  // Nurses
  GET_ALL_NURSES: () => `${getApiBaseUrl()}/users/staff`,
  GET_DOCTOR_NURSES: (doctorId: number) => `${getApiBaseUrl()}/users/staff?doctor_id=${doctorId}`,
  RESEND_EMAIL_TO_STAFF: (staffId: number) =>
    `${getApiBaseUrl()}/users/resend-staff-email?id=${staffId}`,
  DELETE_STAFF: (staffId: number) => `${getApiBaseUrl()}/users/delete-staff?id=${staffId}`,

  // Billing Personnel Invite Cancellation
  CANCEL_BILLER_INVITE: (id: string | undefined) => `${getApiBaseUrl()}/users/billing-invitations/${id}/cancel`,

  // users
  GET_SPECIFIC_USER: (id: string | undefined) => `${getApiBaseUrl()}/users/${id}`,
  GET_SPECIFIC_STAFF: (id: string | undefined, queryParams?: string | null) =>
    `${getApiBaseUrl()}/users/staff/${id}${queryParams ? `?${queryParams}` : ''}`,
  UPDATE_STAFF: (uuid: string | undefined) => `${getApiBaseUrl()}/users/staff/${uuid}`,
  INVITE_USER: (role: string | null, doctorId?: number | null) =>
    `${getApiBaseUrl()}/users/invite-user?role=${role}&doctor_id=${doctorId || null}`,
  UPDATE_USER_STATUS: (id: number | undefined, status: number | undefined) =>
    `${getApiBaseUrl()}/users/update-status/${id}?status=${status}`,
  EDIT_PROFILE: (id: number) => `${getApiBaseUrl()}/users/edit-profile/${id}`,
  // Get all staff (nurses) assigned to a specific doctor
  GET_DOCTOR_STAFF: (doctorId: number | string) => `${getApiBaseUrl()}/users/${doctorId}/staff`,
  GET_DOCTOR_ACTIVE_STAFF: (doctorId: number | string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/users/${doctorId}/active-staff${queryParams ? `?${queryParams}` : ''}`,

  // time-tracked
  CREATE_TIME_TRACKED_ENTRY: (trackedBy: number, patientId: any, today_date_time?: string) =>
    `${getApiBaseUrl()}/time-tracked/create/${trackedBy}/${patientId}${
      today_date_time ? `?today_date_time=${today_date_time}` : ''
    }`,
  // TODO:: Change to /patient/{patientUUID} with BE change
  GET_TIME_TRACKED_ENTRIES_OF_PATIENT: (userId?: any, patientId?: any, userRole?: string, doctorId?: number) => {
    const params: string[] = []
    if (userRole && userRole !== 'undefined') {
      params.push(`user_role=${userRole}`)
    }
    if (doctorId) {
      params.push(`doctor_id=${doctorId}`)
    }
    const queryString = params.length > 0 ? `?${params.join('&')}` : ''
    return `${getApiBaseUrl()}/time-tracked/${userId}/${patientId}${queryString}`
  },
  // TODO:: Change to /clinic with FE change
  GET_ALL_TIME_TRACKED_ENTRIES: (doctorId?: number) =>
    `${getApiBaseUrl()}/time-tracked/staff-entries/?doctor_id=${doctorId}`, // TODO::Remove - pick from BE session in API
  DELETE_TIME_TRACKED_ENTRY: (id: number) => `${getApiBaseUrl()}/time-tracked/delete/${id}`,
  UPDATE_TIME_TRACKED_ENTRY: (id: number) => `${getApiBaseUrl()}/time-tracked/update/${id}`,

  // Billing Report Routes
  GET_ALL_BILLING_REPORT: (queryParams?: string | null) =>
    `${getApiBaseUrl()}/billing/report${queryParams ? `?${queryParams}` : ''}`,
  GET_ADMIN_BILLING_REPORT: (queryParams?: string | null) =>
    `${getApiBaseUrl()}/admin/billing/report${queryParams ? `?${queryParams}` : ''}`,
  GET_BILLING_REPORT_BY_PATIENT: (patientUUID: string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/billing/report/${patientUUID}${queryParams ? `?${queryParams}` : ''}`,
  GET_PATIENT_DETAILED_BILLING_REPORT: (
    patientUUID: string,
    billingCycleId: number | string
  ) =>
    `${getApiBaseUrl()}/billing/report/${patientUUID}/cycles/${billingCycleId}/detailed-report`,
  GET_BILLING_CYCLE_ENDING_REPORT: (queryParams?: string | null) =>
    `${getApiBaseUrl()}/doctors/billing-cycle-ending-stats?status=active${
      queryParams ? `&${queryParams}` : ''
    }`,

  // Billing Cycle Routes
  GET_PATIENT_LATEST_BILLING_CYCLE: (patientUUID: string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/billing-cycle/latest/${patientUUID}${queryParams ? `?${queryParams}` : ''}`,
  GET_PATIENT_COUNT_BY_CARE_MINS_GROUPS: (queryParams?: string | null) =>
    `${getApiBaseUrl()}/billing-cycle/pt-count-by-time-groups${queryParams ? `?${queryParams}` : ''}`,

  //Admin
  GET_ALL_DEVICES_REQUESTED_BY_DOCTORS: () => `${getApiBaseUrl()}/device-request/all`,
  UPDATE_DEVICE_STATUS: (requestId: number) =>
    `${getApiBaseUrl()}/device-request/${requestId}/status`,
  ASSIGN_DEVICE_TO_DOCTOR: () => `${getApiBaseUrl()}/doctor-allocated-devices/`,
  ASSIGN_MULTIPLE_DEVICES_TO_DOCTOR: () => `${getApiBaseUrl()}/doctor-allocated-devices/multiple`,
  UNASSIGN_DEVICE_FROM_DOCTOR: (deviceId: number | string) =>
    `${getApiBaseUrl()}/doctor-allocated-devices/unassign/${deviceId}`,
  UPDATE_DEVICE_ALLOCATION_STATUS: (doctorAllocatedDeviceId: number | string) =>
    `${getApiBaseUrl()}/doctor-allocated-devices/${doctorAllocatedDeviceId}/update-status`,
  //Admin with Admin end-point
  GET_ALL_PATIENTS_FOR_ADMIN: (queryParams?: string | null) =>
    `${getApiBaseUrl()}/admin/patients?${queryParams ? `${queryParams}` : ''}`,

  // Device Allocations
  GET_ALL_PATIENT_ASSIGNED_DEVICES: (patientUuid: string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/device-allocation/patient/${patientUuid}${queryParams ? `?${queryParams}` : ''}`,
  UNASSIGN_PATIENT_DEVICE: (id: string | number) => `${getApiBaseUrl()}/device-allocation/${id}`,
  ASSIGN_PATIENT_DEVICE: (uuid: string | number) =>
    `${getApiBaseUrl()}/device-allocation/patient/${uuid}`,

  // Criticality Settings
  CREATE_NEW_CRITICALITY_SETTINGS: () => `${getApiBaseUrl()}/criticality-setting`,
  CREATE_PATIENT_CRITICALITY_SETTINGS: (patient_uuid: string, isNurse: boolean | null, queryParams?: string | null) =>
    `${getApiBaseUrl()}/criticality-setting/patients-general-settings?patient_uuid=${patient_uuid}&is_nurse=${
      isNurse ? 1 : 0
    }${queryParams ? `&${queryParams}` : ''}`,
  GET_ALL_CRITICALITY_SETTINGS: (queryParams?: string) =>
    `${getApiBaseUrl()}/criticality-setting${queryParams ? `?${queryParams}` : ''}`, // used for both doctors and nurse
  GET_ALL_PATIENT_CRITICALITY_SETTINGS: (patientUuid: string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/criticality-setting/${patientUuid}${queryParams ? `?${queryParams}` : ''}`, // used for both doctors and nurse

  // transactions
  DEVICE_PAYMENT: () => `${getApiBaseUrl()}/transactions/create-checkout-session`,
  STORE_TRANSACTION: () => `${getApiBaseUrl()}/transactions/store-transaction`,
  GET_DOCTOR_TRANSACTIONS: (doctorUUID: string) =>
    `${getApiBaseUrl()}/transactions/get-user-transactions/${doctorUUID}`,
  GET_ALL_TRANSACTIONS: () => `${getApiBaseUrl()}/transactions/get-all-transactions`,

  // Notifications
  GET_ALL_HEALTH_ALERTS: (patientUUID: string) =>
    `${getApiBaseUrl()}/notification/alerts?patient_uuid=${patientUUID}`,
  GET_HEALTH_ALERT_REVIEWED: (id?: string | number) =>
    `${getApiBaseUrl()}/notification/status-toggle/${id}`,
  CLEAR_ALL_HEALTH_ALERTS: () => `${getApiBaseUrl()}/notification/clear_alerts`,
  // FCM Token
  FCM_TOKEN: (userId?: number | string) =>
    `${getApiBaseUrl()}/fcm-token${userId ? `?user_id=${userId}` : ''}`,

  // Device Requests
  GET_ALL_DEVICES_REQUESTED_BY_A_DOCTOR: (doctorId: string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/device-request/doctor/${doctorId}${queryParams ? `?${queryParams}` : ''}`,

  // BP-Alert Settings (doctor-level)
  GET_BP_ALERT_SETTINGS: (doctorId: number | string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/bp-alerts/doctors/${doctorId}/settings${queryParams ? `?${queryParams}` : ''}`,
  UPDATE_BP_ALERT_SETTINGS: (doctorId: number | string) =>
    `${getApiBaseUrl()}/bp-alerts/doctors/${doctorId}/settings`,

  // BP-Alert Overrides (per-patient)
  GET_BP_ALERT_OVERRIDES: (patientId: number | string) =>
    `${getApiBaseUrl()}/bp-alerts/patients/${patientId}/overrides`,
  UPDATE_BP_ALERT_OVERRIDES: (patientId: number | string) =>
    `${getApiBaseUrl()}/bp-alerts/patients/${patientId}/overrides`,
  GET_ALL_NOTIFICATIONS_FOR_CURRENT_USER: () => `${getApiBaseUrl()}/notification-request}`,

  // s3-image-upload
  UPLOAD_IMAGE_TO_S3: (queryParams?: string | null) =>
    `${getApiBaseUrl()}/s3/presign${queryParams ? `?${queryParams}` : ''}`,
  GET_PRE_SIGNED_URL: (key: any) => `${getApiBaseUrl()}/s3/get-presigned-url/${key}`,

  // sub-admins
  GET_ALL_SUB_ADMINS: () => `${getApiBaseUrl()}/users/sub-admin`,
  // Medical Assistants
  GET_ALL_MEDICAL_ASSISTANTS: () => `${getApiBaseUrl()}/users/medical-assistants`,
  // Admin Dashboard
  ADMIN_TOTAL_USERS: () => `${getApiBaseUrl()}/admin-dashboard/total-users`,
  ADMIN_SUBSCRIPTION_STATUS: () => `${getApiBaseUrl()}/admin-dashboard/subscription-status`,
  ADMIN_TOTAL_DEVICES: () => `${getApiBaseUrl()}/admin-dashboard/total-devices`,
  ADMIN_PURCHASED_VS_RENTAL: () => `${getApiBaseUrl()}/admin-dashboard/purchased-vs-rental`,
  ADMIN_TOTAL_PATIENTS: () => `${getApiBaseUrl()}/admin-dashboard/total-patients`,
  ADMIN_TOTAL_SUBADMINS: () => `${getApiBaseUrl()}/admin-dashboard/total-subadmins`,
  ADMIN_DEVICE_UTILIZATION: () => `${getApiBaseUrl()}/admin-dashboard/device-utilization`,
  ADMIN_PATIENT_COMPLIANCE: () => `${getApiBaseUrl()}/admin-dashboard/patient-compliance`,
  ADMIN_OVERRIDE_DOCTOR_TRIAL: (doctorId: number) =>
    `${getApiBaseUrl()}/users/${doctorId}/override-trial`,

  /** Billing personnel self-registration via invitation token */
  SEND_INVITE_TO_BILLING_PERSONNEL: () => `${getApiBaseUrl()}/users/billing-personnel/invite`,
  GET_DOCTORS_FOR_BILLING_PERSONNEL: (personnelId: string) =>
    `${getApiBaseUrl()}/users/billing-personnel/${personnelId}/doctors`,
  GET_BILLER_INVITATION: (token: string) =>
    `${getApiBaseUrl()}/users/billing-personnel/invitation/${token}`,
  REGISTER_BILLING_PERSONNEL_VIA_TOKEN: () => `${getApiBaseUrl()}/users/billing-personnel/register`,
  UNLINK_BILLING_PERSONNEL: (personnelId: string | number) =>
    `${getApiBaseUrl()}/users/billing-personnel/${personnelId}/unlink`,
  GRANT_BILLING_PERSONNEL_ACCESS: (personnelId: string | number) =>
    `${getApiBaseUrl()}/users/billing-personnel/${personnelId}/grant-access`,

  // stripe
  GET_PAYMENT_METHODS: () => `${getApiBaseUrl()}/stripe/payment-methods`,
  SET_DEFAULT_PAYMENT_METHOD: () => `${getApiBaseUrl()}/stripe/set-default-payment`,
  DELETE_PAYMENT_METHOD: () => `${getApiBaseUrl()}/stripe/delete-payment-method`,
  CREATE_SETUP_INTENT: () => `${getApiBaseUrl()}/stripe/create-setup-intent`,
  GET_DEFAULT_PAYMENT_METHOD: () => `${getApiBaseUrl()}/stripe/default-card`,
  CREATE_PORTAL_SESSION: () => `${getApiBaseUrl()}/stripe/create-portal-session`,
  CREATE_SUBSCRIPTIONS: () => `${getApiBaseUrl()}/transactions/subscription-create`,
  RE_SUBSCRIPTIONS: () => `${getApiBaseUrl()}/transactions/resubscribe`,
  CANCEL_SUBSCRIPTION: () => `${getApiBaseUrl()}/transactions/subscription-cancel`,
  GET_ALL_TRANSACTIONS_FROM_STRIPE: (doctorId: string) =>
    `${getApiBaseUrl()}/transactions/get-invoices?doctor_uuid=${doctorId}`,

  // Doctor Notification Recipients
  GET_DOCTOR_NOTIFICATION_RECIPIENTS: (doctorId: number | string, queryParams?: string | null) =>
    `${getApiBaseUrl()}/doctors/${doctorId}/notification-recipients${queryParams ? `?${queryParams}` : ''}`,
  ADD_DOCTOR_NOTIFICATION_RECIPIENT: (doctorId: number | string) =>
    `${getApiBaseUrl()}/doctors/${doctorId}/notification-recipients`,
  REMOVE_DOCTOR_NOTIFICATION_RECIPIENT: (doctorId: number | string, email: string) =>
    `${getApiBaseUrl()}/doctors/${doctorId}/notification-recipients/${encodeURIComponent(email)}`,

  // Settings
  GET_ALL_SETTINGS: () => `${getApiBaseUrl()}/settings`,
  GET_ACCESSIBLE_SETTINGS: () => `${getApiBaseUrl()}/settings/accessible`,
  GET_SETTING: (key: string) => `${getApiBaseUrl()}/settings/${key}`,
  UPDATE_SETTING: (key: string) => `${getApiBaseUrl()}/settings/${key}`,
  DELETE_SETTING: (key: string) => `${getApiBaseUrl()}/settings/${key}`,
}
